import React from 'react';
import './App.css';
import HomePageContainer from "./containers/HomePage";

function App() {
  return (
    <div className="App">
      <HomePageContainer/>
    </div>
  );
}

export default App;
